import { Selector } from '@ngxs/store';
import { GroupManagementState, GroupManagementStateModel } from './group-management.state';

export class GroupManagementSelectors {
  @Selector([GroupManagementState])
  static groups(state: GroupManagementStateModel) {
    return state.groups;
  }

  @Selector([GroupManagementState])
  static selected(state: GroupManagementStateModel) {
    return state.selected;
  }

  @Selector([GroupManagementState])
  static users(state: GroupManagementStateModel) {
    return state.users;
  }

  @Selector([GroupManagementState])
  static initializing(state: GroupManagementStateModel) {
    return state.initializing;
  }

  @Selector([GroupManagementState])
  static saving(state: GroupManagementStateModel) {
    return { saving: state.saving, errorMessage: state.errorMessage };
  }

  @Selector([GroupManagementState])
  static editing(state: GroupManagementStateModel) {
    return state.editing;
  }

  @Selector([GroupManagementState])
  static loadingUsers(state: GroupManagementStateModel) {
    return state.loadingUsers;
  }

  @Selector([GroupManagementState])
  static removingUsers(state: GroupManagementStateModel) {
    return state.removingUsers;
  }
}
